
// 隐私政策
import {computed, defineComponent, reactive, toRefs} from "vue";
import Protocol from '@/components/ProtocolSet.vue'

interface IState {
  detail: string
  loading: boolean,
}

export default defineComponent({
  name: "ProtocolDetail",
  components: {Protocol},
  setup() {
    const state = reactive({
      activeKey: 'courier_privacy',
      loading: false,
      // courier_service(用户协议)，courier_welfare(司机福利)，courier_privacy(隐私政策)，courier_settled(入驻协议)
      tabs: [
        {
          name: '司机隐私政策',
          id: 'courier_privacy'
        },
        {
          name: '司机用户协议',
          id: 'courier_service'
        },
        {
          name: '入驻协议',
          id: 'courier_settled'
        },
        {
          name: '司机福利',
          id: 'courier_welfare'
        },
        {
          name: '用户协议',
          id: 'service'
        },
        {
          name: '隐私政策',
          id: 'privacy'
        },
        {
          name: '用户福利',
          id: 'welfare'
        },
        {
          name: '防疫报备协议',
          id: 'postNotice'
        },
      ]
    })

    const title = computed(() => {
      return state.tabs.find(e => e.id === state.activeKey)?.name || '协议配置'
    })

    const setActive = (key: string) => {
      state.loading = true
      setTimeout(() => {
        state.activeKey = key
        state.loading = false
      }, 10)
    }

    return {
      ...toRefs(state),
      title,
      setActive,
    }
  }
})
